import { useTranslation } from 'react-i18next';
import RuleCondition from '../RuleCondition';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { addCondition } from 'components/Rules/helpers/ruleUpdates';
import RuleConditionsFields from 'components/Rules/RuleConditions';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import { EConditionType, ERuleType } from 'types/rules.types';
import type { TQuestionRule } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
}

const RuleConditions = ({ rule }: Props) => {
  const { t } = useTranslation('Templates');
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <RuleConditionsFields
      isReadOnly={isReadOnly}
      conditions={rule.conditions}
      renderCondition={(condition, conditionIdx) => (
        <RuleCondition key={condition.id} rule={rule} condition={condition} conditionIdx={conditionIdx} />
      )}
      addLabel={t('question.ruleConditions.addConditionButton')}
      onAdd={() => {
        const type = rule.type === ERuleType.DO_IF ? EConditionType.QuestionAnswer : EConditionType.InterviewProperty;
        dispatch(upsertQuestionRule({ questionId, rule: addCondition(rule, type) }));
      }}
    />
  );
};

export default RuleConditions;
